export default __webpack_public_path__ + "static/media/close-icon-white.a8f7ad99.svg";